import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import styled from "styled-components";
import ClubEvent from "./ClubEvent";
import events from "../../components/clubevents/events.json";
import program from "./program.json";
import NextMonthTeaser from "./NextMonthTeaser";

const Wrapper = styled.div`
    width: 100%;

    &:hover {
        opacity: 0.8;
        cursor: pointer;
    }
`;

const fetchEvents = async (setApiEvents) => {
    const response = await fetch("https://events.lepaff.workers.dev");
    const events = await response.json();
    setApiEvents(events);
};

function nextMonthKey() {
    const parts = new Intl.DateTimeFormat("en-CA", {timeZone: "Europe/Sofia", year: "numeric", month: "2-digit"}).formatToParts(new Date());
    const year = +parts.find(p => p.type === "year").value, month = +parts.find(p => p.type === "month").value;
    return month === 12 ? `${year + 1}-01` : `${year}-${String(month + 1).padStart(2, "0")}`;
}

const ClubEvents = ({ isMain }) => {
    const [apiEvents, setApiEvents] = useState([]);
    const { i18n } = useTranslation();
    const today = new Date();
    const validEvents = events.filter(
        (event) => new Date(event.utfDate) > today && event.image !== undefined
    );

    useEffect(() => {
        fetchEvents(setApiEvents);
    }, []);

    // „Очаквайте <следващия месец>“ + общата визия стои след вечерите на текущия месец,
    // докато за следващия месец няма качени отделни вечери. Щом се качат (около 20-о число), визията изчезва.
    // Без визия за следващия месец не се показва нищо.
    const nextKey = nextMonthKey();
    const teaser = <NextMonthTeaser key="next-month" monthKey={nextKey} visual={program[nextKey]}/>;
    const items = validEvents.map((event, index) => (
        <Wrapper key={index}>
            <Link to={`/${i18n.language}/events/${event.date}`}>
                <ClubEvent event={event} index={index} />
            </Link>
        </Wrapper>
    ));
    if (!program[nextKey]) return items;
    const nextMonthHasEvents = validEvents.some((event) => event.date.startsWith(nextKey));
    return nextMonthHasEvents ? items : [...items, teaser];
};

export default ClubEvents;